

/// <reference path="Product.ts" />

// Generated class OnlinePreset_ManagedObject

class OnlinePreset_ManagedObject extends Product
{
}
